// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Partners_partnersSection__qXXvB {
    background: #050518;
    padding: 64px 0;
}

.Partners_partnersContainer__Nli33 {
  width: 100%;
  max-width: 90%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}
.Partners_partnersTitle__m8atH {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 48px;
  color: #b4b4ba;
}

.Partners_partnersTrack__YEMqe {
  display: flex;
  animation: Partners_scroll__t1itj 20s linear infinite;
  width: fit-content;
}

.Partners_partnerLogo__UiTzH {
  padding: 0 30px;
}

.Partners_partnerLogo__UiTzH img {
  height: 32px;
  object-fit: contain;
  filter: grayscale(100%) brightness(0) invert(1);
  transition: opacity 0.3s;
}

.Partners_partnerLogo__UiTzH img:hover {
  opacity: 1;
}

@keyframes Partners_scroll__t1itj {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Partners/Partners.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qDAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".partnersSection {\n    background: #050518;\n    padding: 64px 0;\n}\n\n.partnersContainer {\n  width: 100%;\n  max-width: 90%;\n  margin: 0 auto;\n  overflow: hidden;\n  position: relative;\n}\n.partnersTitle {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n  margin-bottom: 48px;\n  color: #b4b4ba;\n}\n\n.partnersTrack {\n  display: flex;\n  animation: scroll 20s linear infinite;\n  width: fit-content;\n}\n\n.partnerLogo {\n  padding: 0 30px;\n}\n\n.partnerLogo img {\n  height: 32px;\n  object-fit: contain;\n  filter: grayscale(100%) brightness(0) invert(1);\n  transition: opacity 0.3s;\n}\n\n.partnerLogo img:hover {\n  opacity: 1;\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"partnersSection": `Partners_partnersSection__qXXvB`,
	"partnersContainer": `Partners_partnersContainer__Nli33`,
	"partnersTitle": `Partners_partnersTitle__m8atH`,
	"partnersTrack": `Partners_partnersTrack__YEMqe`,
	"scroll": `Partners_scroll__t1itj`,
	"partnerLogo": `Partners_partnerLogo__UiTzH`
};
export default ___CSS_LOADER_EXPORT___;
